import { helper as buildHelper } from '@ember/component/helper';

export function messageCenterIsMyMessage(params/*, hash*/) {
  const [message, user] = params;

  return (message.get('userId').toString() === user.get('id').toString());
}

export default buildHelper(messageCenterIsMyMessage);
